import React from 'react';
import ProjectDetail from './ProjectDetail';
import { projectMeta } from './data';
import { toCdn } from '../utils/cdn';
import Figure from '../components/Figure';
import ProgressiveImg from '../components/ProgressiveImg';

export default function GolfGoals() {
  const meta = projectMeta.golfgoals;
  return (
    <ProjectDetail title={meta.title} date={meta.date} role={meta.role} url={meta.url}>
      {/* Custom per-project content goes here */}

      <p>When I started golfing, I wanted a simple way to celebrate progress—the small wins that make the game addictive. Most golf apps focused on scorecards and shot analytics, but none captured the sense of achievement I was after. So I built Golf Goals—a personal milestone tracker inspired by Apple Fitness awards, but for golfers.</p>

      <p>Each goal is visualized as a 3D golf ball with its own custom texture, rendered using RealityKit and Blender. The app turns progress into something tangible and fun—every accomplishment feels like unlocking a new trophy.</p>

      <p>I built the app in a just few months over the Spring of 2025, and launched on the App Store in May. My plan is to continue to iterate on the app and add new features as I learn more.</p>

      <div className="media-gallery">

        <Figure caption="Goals View">
          <ProgressiveImg
            src={toCdn('/images/projects/golfgoals/golfgoals_1.webp')}
            alt="Goals View"
            className="gallery-item"
          />
        </Figure>

        <Figure caption="Goal Creation View">
          <ProgressiveImg
            src={toCdn('/images/projects/golfgoals/golfgoals_2.webp')}
            alt="Goal Creation View"
            className="gallery-item"
          />
        </Figure>

        <Figure caption="Golf Ball Renders">
          <ProgressiveImg
            src={toCdn('/images/projects/golfgoals/golfgoals_3.webp')}
            alt="Golf Ball Renders"
            className="gallery-item"
          />
        </Figure>
        <Figure caption="Course View & Shot Tracer">
          <ProgressiveImg
            src={toCdn('/images/projects/golfgoals/golfgoals_4.webp')}
            alt="Course View & Shot Tracer"
            className="gallery-item"
          />
        </Figure>
      </div>
    </ProjectDetail>
  );
}
